import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import {SectionHeader} from '../Heading/SectionHeader';
import {SmallBlueButton, SmallLightBlueButton} from './ButtonMix';

const Wrapper = styled.div`
  margin: 1rem 0;
`;

const ToggleContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const Value = styled.span`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #2E2E33;
  font-size: 32px;
  font-weight: bold;
  line-height: 38px;
`;

const PlusMinusToggle = ({onChange, toggleAmount, value, sectionHeader}) => {
  const onIncrement = () => onChange(value + toggleAmount);
  
  const onDecrement = () => {
    // don't ever decrement less than zero
    const decrementBy = value === 0 ? 0 : toggleAmount;
    onChange(value - decrementBy);
  };
  
  return (
    <Wrapper>
      {sectionHeader && <SectionHeader>{sectionHeader}</SectionHeader>}
      <ToggleContainer>
        <SmallLightBlueButton icon="minus" onClick={onDecrement}/>
        <Value>{value}</Value>
        <SmallBlueButton icon="plus" onClick={onIncrement}/>
      </ToggleContainer>
    </Wrapper>
  );
};

PlusMinusToggle.propTypes = {
  onChange: PropTypes.func.isRequired,
  toggleAmount: PropTypes.number,
  value: PropTypes.number.isRequired,
  sectionHeader: PropTypes.string
};
PlusMinusToggle.defaultProps = {
  toggleAmount: 1
};

export default PlusMinusToggle;



// WEBPACK FOOTER //
// ./src/components/Button/PlusMinusToggle.js